import script from "./PagesRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesRoute.vue?vue&type=script&setup=true&lang=js"

import "./PagesRoute.vue?vue&type=style&index=0&id=a35134c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a35134c4"]])

export default __exports__